import { useRef, useContext, useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";

import '../../../assets/css/botonNotificaciones.css'
import tGPS from '../../../assets/images/iconoMenuPrincipal.png'
import tREC from '../../../assets/images/iconoMenuPrincipal.png'
import tSIR from '../../../assets/images/iconoMenuPrincipal.png'
import tMAN from '../../../assets/images/iconoMenuPrincipal.png'
import tXlite from '../../../assets/images/iconoMenuPrincipal.png'
import tGAC from '../../../assets/images/iconoMenuPrincipal.png'
// import { useMenu } from '../../../hooks/useMenu';

import { UserContext } from '../../../context/provider/UserProvider';


export const BotonMenuPrincipal = (props) => {
    const { cambiarModulo } = useContext(UserContext);
    const [ mostrar, setMostrar ] = useState(false)
    const dropDownNotify = useRef()
    const history = useHistory();

    useEffect(()=> {
        document.addEventListener('mousedown',(event) =>{
            if(mostrar && dropDownNotify.current &&
                !dropDownNotify.current.contains(event.target)
            ){
                setMostrar(false)
            }
        })
    },[mostrar])


    const irGac =()=>{
        cambiarModulo("tgac")
        history.push('/tgac')
    }

    // const menusPrincipal = [
    //     {codMenu: 1, nombreMenu:"X-BEST",icono:tGPS},
    //     {codMenu: 2, nombreMenu:"X-GAC",icono:tGPS},
    //     {codMenu: 3, nombreMenu:"X-TEL",icono:tGPS},
    //     {codMenu: 4, nombreMenu:"X-MAN",icono:tGPS},
    //     {codMenu: 5, nombreMenu:"RRHH",icono:tGPS},
    //     {codMenu: 6, nombreMenu:"PLANILLA",icono:tGPS},
    //     {codMenu: 7, nombreMenu:"X-PROJECT",icono:tGPS},
    //     {codMenu: 8, nombreMenu:"X-APM",icono:tGPS},
    //     {codMenu: 9, nombreMenu:"X-TALLER",icono:tGPS},
    // ]
    const menusPrincipal = [
        {codMenu: 7, nombreMenu:"X-PROJECT",icono:tGPS},
    ]

    return (
        <>

            <button  onClick={() => setMostrar(!mostrar)} className=' fa fa-home px-1 py-1 hover:bg-blue-600 rounded'>
            </button>

            <div
                key={'opciones'}
                ref={dropDownNotify}
                className={`bg-gray-800 absolute top-[40px] ${!mostrar ? ' hidden ': ''} z-50 w-[180px] right-0 rounded-xl  shadow`}
            >
                {   
                    menusPrincipal?.length > 0 
                    ? menusPrincipal.map((mp, i) => {
                        return (
                            <li key={i+1} className="flex  py-2  px-2  hover:bg-blue-900 hover:text-white rounded cursor-pointer" onClick={()=>irGac()}>
                                <img src={mp.icono} className='m-1 w-[40px] h-[40px]' alt=""/><span className='ml-2 mt-3'>{mp.nombreMenu}</span>
                            </li>
                        )
                    })
                    : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                }

            </div> 
        </>

    )
}
























